import { render, staticRenderFns } from "./ShareActivity.vue?vue&type=template&id=67e64f6b&"
import script from "./ShareActivity.vue?vue&type=script&lang=js&"
export * from "./ShareActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports